import { useEffect } from 'react';
import { useUIStore } from '@/shared/stores/uiStore';
import { useAuthStore } from '@/shared/stores/authStore';
import { AppProviders } from './providers';
import { AppRoutes } from './routes';
import { ToastContainer } from '@/shared/components/molecules/ToastContainer/ToastContainer';
import '@/styles/global.css';

/**
 * App Component
 * Root application component
 */
function App() {
    const { theme } = useUIStore();
    const { tenant } = useAuthStore();

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);

    // Apply Tenant Branding
    useEffect(() => {
        const color = tenant?.primary_color || tenant?.primaryColor;
        const accent = tenant?.accent_color;
        if (color) {
            document.documentElement.style.setProperty('--accent-primary', color);
            document.documentElement.style.setProperty('--accent-hover', `${color}ee`);
        } else {
            document.documentElement.style.removeProperty('--accent-primary');
            document.documentElement.style.removeProperty('--accent-hover');
        }
        if (accent) {
            document.documentElement.style.setProperty('--accent-secondary', accent);
        } else {
            document.documentElement.style.removeProperty('--accent-secondary');
        }
    }, [tenant]);

    return (
        <div className="app-root">
            {/* Global Animated Background */}
            <div className="global-bg-mesh">
                <div className="global-bg-orb global-bg-orb-1" />
                <div className="global-bg-orb global-bg-orb-2" />
                <div className="global-bg-orb global-bg-orb-3" />
            </div>

            <AppProviders>
                <AppRoutes />
                <ToastContainer />
            </AppProviders>
        </div>
    );
}

export default App;
